import { render, staticRenderFns } from "./DnFunctionButton.vue?vue&type=template&id=bc228f34"
import script from "./DnFunctionButton.vue?vue&type=script&lang=js"
export * from "./DnFunctionButton.vue?vue&type=script&lang=js"
import style0 from "./DnFunctionButton.vue?vue&type=style&index=0&id=bc228f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports